import type { FC } from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { getStudioParams } from '../../../../selectors/studio';
import { illustrationUrl } from '../../StudioBlankSlate';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';
import { BiData, PostFromFeedBiEvent } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '@wix/da-shared-react/pkg/types/deviation';

const POSTS_IMG_URL = illustrationUrl('studio-status-empty.png', 0);

const PostsBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(
      pushModal(ModalType.STATUS_UPDATE, {
        wrapInModal: false,
        params: {},
      })
    );
  }, [dispatch]);

  const { tierId } = useSelector(getStudioParams);

  return (
    <BasicBlankSlate
      illustrationSrc={POSTS_IMG_URL}
      title={t(tierId ? 'studio.blankSlate.tierPosts.title' : 'studio.blankSlate.posts.title')}
      message={t(
        tierId ? 'studio.blankSlate.tierPosts.message' : 'studio.blankSlate.posts.message'
      )}
      ctaLabel={t(
        tierId ? 'studio.blankSlate.tierPosts.ctaLabel' : 'studio.blankSlate.posts.ctaLabel'
      )}
      ctaOnClick={onClick}
      ctaBiData={BiData<PostFromFeedBiEvent>({
        evid: 117,
        typeid: DeviationResourceType.STATUS_DEVIATION,
        is_from_textbox: 0,
        sectionname: 'posts_empty',
      })}
    />
  );
};
PostsBlankSlate.displayName = 'PostsBlankSlate';

export default PostsBlankSlate;
